import React from 'react';
import { connect } from '@souche-f2e/muji';
import { Modal, Table, message, Button, Input, Icon } from 'antd';
import modalStyle from '../_style/modal.less';
import { dispatch } from '@@/store';
const mapStateToProps = (rootState) => {
    return {
        report: rootState.reportCreate,
    };
};
class ReportModal extends React.Component {
    constructor(props) {
        super(props);
        this.changePage = this.changePage.bind(this);
        this.querySession = this.querySession.bind(this);
        this.confirmChecked = this.confirmChecked.bind(this);
        this.resetQuery = this.resetQuery.bind(this);
        this.changeCheckedItem = this.changeCheckedItem.bind(this);
        this.changeCheckedPage = this.changeCheckedPage.bind(this);
        this.changeChecked = this.changeChecked.bind(this);
        this.$input = React.createRef();
    }
    // desc 条件搜索
    querySession() {
        const sessionCode = this.$input.current.state.value || '';
        dispatch.reportCreate.getSessionList({
            sessionCodeParams: sessionCode,
            pageIndex: 1,
        });
    }
    // desc 翻页
    changePage(index) {
        dispatch.reportCreate.getSessionList({
            pageIndex: index,
        });
    }
    // desc 确定场次选择
    confirmChecked() {
        dispatch.reportCreate.confirmCheckedSession({});
    }
    // desc 重置搜索条件 sessionCode pageIndex total
    resetQuery() {
        dispatch.reportCreate.cancelCheckedSession({});
    }
    // desc 表格点选选择
    changeCheckedItem(row, selected, selectedRows, event) {
        selected ? this.changeChecked([row]) : this.cancelChecked([row]);
    }
    // desc 表格整页选择
    changeCheckedPage(selected, selectedRows, changeRows) {
        selected ? this.changeChecked(changeRows) : this.cancelChecked(changeRows);
    }
    // desc 表格选中项
    changeChecked(selectedRows) {
        const { sessionMaxCheckedNum, sessionCheckedListModal, } = this.props.report;
        let checkedRows = [...sessionCheckedListModal, ...selectedRows];
        if (checkedRows.length > sessionMaxCheckedNum) {
            checkedRows = checkedRows.slice(0, sessionMaxCheckedNum);
            message.warning({
                content: `最多可选择${sessionMaxCheckedNum}个场次`,
            });
        }
        dispatch.reportCreate.SET_STATE({
            sessionCheckedListModal: checkedRows,
        });
    }
    // desc 表格取消选中项
    cancelChecked(cancelRows) {
        const { sessionMaxCheckedNum, sessionCheckedListModal, } = this.props.report;
        if (cancelRows.length === sessionMaxCheckedNum) {
            dispatch.reportCreate.SET_STATE({
                sessionCheckedListModal: [],
            });
            return;
        }
        const cancelCodeList = cancelRows.map((item) => {
            return item.sessNum;
        });
        const checkedRows = sessionCheckedListModal.filter((item) => {
            return !cancelCodeList.includes(item.sessNum);
        });
        dispatch.reportCreate.SET_STATE({
            sessionCheckedListModal: checkedRows,
        });
    }
    render() {
        const { sessionTableColumns, sessionTableData, sessionPageIndex, sessionPageSize, sessionDataTotal, sessionCheckedListModal, sessionMaxCheckedNum, showSessionCheck, } = this.props.report;
        const checkedSession = sessionCheckedListModal.map((item) => item.sessNum);
        return (<Modal className="draw_table_all_border" width={800} visible={showSessionCheck} centered={true} footer={<div className={modalStyle.modal_footer}>
            <div className={modalStyle.modal_footer_desc}>
              已选({sessionCheckedListModal.length}/{sessionMaxCheckedNum})
            </div>
            <Button type={'primary'} onClick={this.confirmChecked} style={{ width: '76px' }}>确定</Button>
          </div>} title={<>
            <span className={modalStyle.tital_mostly}>添加拍卖场次</span>
            <span className={modalStyle.title_secondary}>仅显示拍卖结束的场次</span>
          </>} onCancel={this.resetQuery}>
        <Input ref={this.$input} placeholder={'场次编号'} className={modalStyle.modal_input} suffix={<div className={modalStyle.modal_search} onClick={this.querySession}>
              <Icon type="search"/>
            </div>}/>
        <Table rowKey={'sessNum'} columns={sessionTableColumns} dataSource={sessionTableData} pagination={{
            size: 'small',
            current: sessionPageIndex,
            total: sessionDataTotal,
            pageSize: sessionPageSize,
            onChange: this.changePage,
        }} rowSelection={{
            selectedRowKeys: checkedSession,
            onSelect: this.changeCheckedItem,
            onSelectAll: this.changeCheckedPage,
        }}/>
      </Modal>);
    }
}
export default connect(mapStateToProps)(ReportModal);
